var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-pagination',_vm._g({attrs:{"value":_vm.value,"length":_vm.length,"disabled":_vm.disabled,"total-visible":_vm.totalVisible,"color":"color-blue"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }